const initialState = {
  lockOAuthData: false,
  lockEsiaData: false,
  lockTinkoffData: false,
};

export const oauthReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case "LOCK_ESIA_DATA": {
      const lockEsiaData = action.payload;
      return {
        ...state,
        lockEsiaData,
        lockOAuthData: lockEsiaData || state.lockTinkoffData,
      };
    }
    case "LOCK_TINKOFF_DATA": {
      const lockTinkoffData = action.payload;
      return {
        ...state,
        lockTinkoffData,
        lockOAuthData: lockTinkoffData || state.lockEsiaData,
      };
    }
    default:
      return state;
  }
};
